export default __webpack_public_path__ + "static/media/gateway-status.9b9d070f.svg";